<nav class="sidebar" [ngClass]="{sidebarPushRight: isActive, collapsed: collapsed}" *transloco="let t; read: 'sidebar'">
  <div class="list-group">


    <div *ngIf="showItem('explore')"  class="nested-menu">
      <a routerLink="/explorar" [routerLinkActive]="['router-link-active']" class="list-group-item">
        <i class="fa fa-fw fa-search "></i>&nbsp;
        <span>{{t('explore')}}</span>
      </a>
    </div>



    <div *ngIf="showItem('archive')"  class="nested-menu">
      <a routerLink="/archivo" [routerLinkActive]="['router-link-active']" class="list-group-item">
        <i class="fa fa-fw fa-files-o"></i>&nbsp;
        <span>Archivo</span>
      </a>
    </div>


    <div *ngIf="showItem('board')"  class="nested-menu">
      <a routerLink="/tablon" [routerLinkActive]="['router-link-active']" class="list-group-item">
        <i class="fa fa-fw fa-newspaper-o"></i>&nbsp;
        <span>{{t('board')}}</span>
      </a>
    </div>

    <div *ngIf="showItem('my_contributions')"  class="nested-menu">
      <a routerLink="/mis_aportes" [routerLinkActive]="['router-link-active']" class="list-group-item">
        <i class="fa fa-fw fa-briefcase"></i>&nbsp;
        <span>Mis aportes</span>
      </a>
    </div>


    <div *ngIf="showItem('messages')"  class="nested-menu">
      <a routerLink="/mensajes" [routerLinkActive]="['router-link-active']" class="list-group-item">
        <i class="fa fa-fw fa-envelope"></i>&nbsp;&nbsp;
        <span>{{t('messages')}}</span>
        <div *ngIf="unreadCount > 0" class="circle-badge">
          <span class="circle-badge-content">{{this.unreadCount}}</span>
        </div>
      </a>
    </div>


    <div *ngIf="showItem('moderate')"  class="nested-menu">
      <a routerLink="/moderar" [routerLinkActive]="['router-link-active']" class="list-group-item">
        <i class="fa fa-fw fa-gavel"></i>&nbsp;
        <span>Moderar</span>
      </a>
    </div>

    <div *ngIf="showItem('admin')" class="nested-menu">
      <a class="list-group-item" (click)="addExpandClass('admin')">
        <i class="fa fa-fw fa-desktop"></i>&nbsp;&nbsp;
        <span>{{t('admin')}}</span>
      </a>
      <li class="nested" [class.expand]="showMenu === 'admin'">
        <ul class="submenu">
          <li>
            <a routerLink="/admin/usuarios" [routerLinkActive]="['router-link-active']" class="list-group-item">
              <i class="fa fa-fw fa-users "></i>&nbsp;
              <span>{{t('users')}}</span>
            </a>
          </li>
          <li *ngIf="showItem('stats')">
            <a routerLink="/admin/stats" [routerLinkActive]="['router-link-active']" class="list-group-item">
              <i class="fa fa-fw fa-bar-chart"></i>&nbsp;
              <span>{{t('stats')}}</span>
            </a>
          </li>
          <li *ngIf="showItem('ajustes')">
            <a routerLink="/admin/ajustes" [routerLinkActive]="['router-link-active']" class="list-group-item">
              <i class="fa fa-fw fa-cogs"></i>&nbsp;
              <span>{{t('settings')}}</span>
            </a>
          </li>
        </ul>
      </li>
    </div>
  </div>
</nav>
